<template>
  <table class="table table-striped table-hover">
    <thead>
      <tr class="font-weight-bold small">
        <th class="text-center" style="width: 100px">{{ $t('#TR-table') }}</th>
        <th>{{ $t('#TR-name') }}</th>
        <th>{{ $t('#TR-date') }}</th>
        <th>{{ $t('#TR-expiration-date') }}</th>
        <th class="text-center" style="width: 100px">{{ $t('#TR-sum') }}</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="order in orders"
          :key="order.guid">
        <td class="text-center">{{ order.tableCode }}</td>
        <td>{{ order.orderName }}</td>
        <td class="small">{{ order.createTime | moment('DD.MM.YYYY, HH:mm') }}</td>
        <td class="small">{{ order.finishTime | moment('DD.MM.YYYY, HH:mm') }}</td>
        <td class="text-center">{{ order.orderSum / 100 }}</td>
        <td class="receipt-btn text-secondary"
            @click="onPreviewOrder(order)">
          <span class="mdi mdi-eye mdi-24px"></span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'TableOrders',
    props: {
      orders: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },

    methods: {
      onPreviewOrder(order) {
        this.$emit('onprevieworder', order);
      }
    }
  };
</script>
